

<div class="message" *ngIf="isInProgress">
  <div style="margin-bottom: 14px;">Uploading...
    <mat-progress-bar mode="determinate" value="{{progress}}"></mat-progress-bar>

 </div>
</div>
<div class="message" *ngIf="isInProgress">
  <mat-progress-bar mode="buffer"></mat-progress-bar>

  <button mat-button (click)="cancelUpload()">Cancel Upload</button>
</div>

<div class="message" *ngIf="completed">
  <h4>
    File has been uploaded successfully!
  </h4>
  <button (click)="resetUpload()">Upload Another File</button>
</div>

<div class="message error" *ngIf="hasFailed">
  Error: {{ error }}
</div>



<div class="documents tab_content" id="content7" data-tab="7">

  <!-- form FORM====================================FORM FORM=====================FORM -->
  <div class="form_input">
    <div class="top">
      <h2 class="title">New Document</h2>
      <!-- <button class="default_secondary-btn">Add New<em class="ti-plus"></em> </button> -->
    </div>

    <form [formGroup]="documentForm">
      <div class="input">
        <label for="">Document Title</label>
        <input type="text" formControlName="DocumentTitle" class="default_input reference-form" />
      </div>
      <div class="input">
        <label for="">Document Type</label>
        <select formControlName="DocumentTypeId" class="default_input reference-form">
          <option *ngFor="let documentType of documentTypes"
          [value]="documentType.id">{{ documentType.DocumentTypeName }}</option>
        </select>
      </div>

      <div class="input">
        <label for="">Document Type code</label>
        <select formControlName="DocumentTypeCodeId" class="default_input reference-form">
          <option *ngFor="let documentTypeCode of documentTypeCodes"
          [value]="documentTypeCode.id">{{ documentTypeCode.DocumentTypeCodeName }}</option>
        </select>
      </div>

      <div class="input">
        <label for="">Third Party Storage(URL)</label>
        <textarea type="text" formControlName="Url" (mouseleave)="doesFileExistwithURL()" class="default_input reference-form" ></textarea>
        <div class="alert alert-danger" *ngIf="!fileExist">
          {{fileExistMsg}}
        </div>
      </div>

      <div class="input">
        <label for="">Classification</label>
        <select formControlName="SecurityId" class="default_input reference-form">
          <option *ngFor="let security of securityClassifications"
          [value]="security.id">{{ security.SecurityClassificationName }}</option>
        </select>
      </div>

      <div class="input">
        <label for="">File Location</label>
        <select formControlName="FileLocationId" class="default_input reference-form">
          <option *ngFor="let fileLocation of fileLocations"
          [value]="fileLocation.id">{{ fileLocation.FileLocationName }}</option>
        </select>
      </div>

      <div class="input">
        <label for="">Remark</label>
        <input type="text"  formControlName="Remarks" class="default_input reference-form" />
      </div>
      <div class="upload_file" *ngIf="(isReady) || (hasFailed)" style="text-align: right">
        <input #file type="file" multiple (change)="onFilesAdded($event)" id="id_number" />
        <span>file name</span>
        <button class="default_secondary-btn" (click)="file.click()">Upload File <em class="ti-file"></em> </button>
      </div>


    </form>

    <div class="btn_holder">
      <button type="submit"  class="default_primary-button" (click)="onSubmit(documentForm.value)" type="submit">
        <ng-container *ngIf="selectedIndex === null">
          Save  &rarr;
        </ng-container>
        <ng-container *ngIf="selectedIndex !== null">
          Update  &rarr;
        </ng-container>
      </button>
      <div class="refresh">
        <button mat-button (click)="onReset()">
           <em class="material-icons">
            settings_backup_restore
            </em> Reset</button>
        </div>
     </div>
  </div>

  <cradua-document-table
[documentTypeCodes]="documentTypeCodes"
[documentTypes]="documentTypes"
[selectedLandTitle]="selectedLandTitle"
[securityClassifications]="securityClassifications"
[fetchDocuments]="fetchDocuments"
[fileLocations]="fileLocations"
(emitSelectDoc)="onSelectDoc($event)"
(emitEdit)="onEdit($event)"
(emitUploadDoc)="onUploadDoc($event)"
(emitSaveManyDoc)="onSaveManyDoc($event)"
*ngIf="isLoadingDocument === false"
></cradua-document-table>

<cradua-list-spinner
*ngIf="isLoadingDocument === true"
>
</cradua-list-spinner>

  </div>

